import PropTypes from 'prop-types';
import { HStack, Tag, Text } from '@chakra-ui/react';
import { resultTextColors } from 'utils/constants/result';

function ScoreTag({ subQuest }) {
  const getTotalScore = () => {
    if (subQuest.subQuestFileSubmission) {
      return subQuest.subQuestFileSubmission.totalScore;
    }

    if (subQuest.subQuestQuiz) {
      return subQuest.subQuestQuiz.totalMark;
    }
    return null;
  };

  const totalScore = getTotalScore();

  const getResultTextColor = (result) => {
    return resultTextColors[result];
  };

  return (
    <HStack mt={2}>
      <Text fontSize="sm" fontWeight="medium">
        Score:
      </Text>
      <Tag
        size="sm"
        colorScheme={getResultTextColor(subQuest?.result)}
        variant="outline"
      >
        {subQuest.score}
        {totalScore !== null && ` / ${totalScore}`}
      </Tag>
    </HStack>
  );
}

ScoreTag.propTypes = {
  subQuest: PropTypes.shape({
    score: PropTypes.number.isRequired,
    result: PropTypes.string.isRequired,
    subQuestFileSubmission: PropTypes.shape({
      totalScore: PropTypes.number,
    }),
    subQuestQuiz: PropTypes.shape({
      totalMark: PropTypes.number,
    }),
  }).isRequired,
};

export default ScoreTag;
